// extracted by mini-css-extract-plugin
export default {"modal":"accidentModal_modal__gxUuO","time_row":"accidentModal_time_row__jfHjK"};